import { http } from '../http-common';
import {
  CalendarEvent,
  CalendarEventListParams,
  CalendarEventPage,
} from '../types/CalendarEvent';

const getAll = (params: CalendarEventListParams) =>
  http.get<CalendarEventPage>('/calendar-events', { params });

const get = (id: number) => http.get<CalendarEvent>(`/calendar-events/${id}`);

const CalendarEventService = {
  getAll,
  get,
};

export default CalendarEventService;
